import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserPageComponent } from './components/user-page/user-page.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'users'
  },
  {
    path: 'users',
    pathMatch: 'full',
    component: UserListComponent
  },
  {
    path: 'users/:id',
    pathMatch: 'full',
    component: UserListComponent
  },
  /* {
       path: 'newuser',
       pathMatch: 'full',
       component: ManageUserComponent
   }*/
  {
    path: 'newuser',
    pathMatch: 'full',
    component: UserPageComponent,
    canDeactivate: [DirtyFormGuard]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
